import { render, staticRenderFns } from "./AddBoardAttachments.vue?vue&type=template&id=40e7748c"
import script from "./AddBoardAttachments.vue?vue&type=script&lang=js"
export * from "./AddBoardAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports